(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customers-say"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  new Swiper('.what-customers-say-v2 .what-customers-say-swiper', {
    slidesPerView: 2,
    spaceBetween: 33,
    loop: true,
    navigation: {
      nextEl: '.what-customers-say-v2 .swiper-button-next',
      prevEl: '.what-customers-say-v2 .swiper-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 30

      },
      768: {
        slidesPerView: 2,
        spaceBetween: 32
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
